import { BuilderContent, Content, fetchOneEntry } from '@builder.io/sdk-react';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { customComponents } from './BuilderIoComponents';

export const BuilderIoPreview: FC = () => {
  const params = useParams();
  const [content, setContent] = useState<BuilderContent | null>(null);

  useEffect(() => {
    fetchOneEntry({
      apiKey: '7cc02c16cad14907bbdb6b11357bcdd7',
      model: 'page',
      query: {
        name: params.name,
      },
    }).then((res) => {
      setContent(res);
    });
  }, []);

  return (
    <div style={{ padding: '10px' }} className="page_content promotions__container">
      <Content
        model="page"
        content={content}
        apiKey={'7cc02c16cad14907bbdb6b11357bcdd7'}
        customComponents={customComponents}
      />
    </div>
  );
};
